"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AnimatedEllipsis;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _reactNativeLoadingDots = _interopRequireDefault(require("react-native-loading-dots"));
var _excluded = ["containerWidth"];
function AnimatedEllipsis(props) {
  var containerWidth = props.containerWidth,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      width: containerWidth
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeLoadingDots["default"], rest));
}